exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NotificationPoints_account_1Ams {\n  padding-right: 30px;\n\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"account": "NotificationPoints_account_1Ams"
};